<mat-card class="mat-elevation-z0 custom_outline">
  <mat-card-header>
    <mat-card-title>INCIDENT DETAILS</mat-card-title>
  </mat-card-header>
  <form>
    <mat-grid-list cols="4" rowHeight="100px">

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; padding: 3px;" >
          <mat-label>Case Number *</mat-label>
          <input matInput [disabled]="true" [(ngModel)]="data.CaseNumber" name="CaseNumber" autocapitalize="characters" [matTooltip]="'Original Agency Case Number Or BRASSTRAX Original Agency Reference Number'">
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; padding: 3px;">
          <mat-label>Date of Occurrence: *</mat-label>
          <input matInput [matDatepicker]="OccurrenceDatePicker" [(ngModel)]="data.OccurrenceDate" name="DTOFOCC" disabled>
          <mat-datepicker-toggle matSuffix [for]="OccurrenceDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #OccurrenceDatePicker></mat-datepicker>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('INCIDENT', data, 'OccurrenceTime') ? 'ChangeHighlight' : ''">
          <mat-label>Time of Occurrence: (HH:MM)</mat-label>
          <input matInput [(ngModel)]="data.OccurrenceTime" mask="Hh:m0" [leadZeroDateTime]="true" name="IncTimeOfOccurrence" [matTooltip]="'Time Format HH:MM'" [disabled]="DisableDelta('INCIDENT', data, 'OccurrenceTime')">
          <mat-hint>{{oldData.OccurrenceTime}}</mat-hint>
        </mat-form-field>

      </mat-grid-tile>

    </mat-grid-list>

    <mat-grid-list cols="4" rowHeight="80px">

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Agency *</mat-label>
          <input type="text" [disabled]="true" matInput [(ngModel)]="data.Dept" name="nibinIncidentAgencyAutoComplete"  >
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; padding: 3px;" >
          <mat-label>Original Agency Ref # *</mat-label>
          <input matInput [disabled]="true" [(ngModel)]="data.LabNumber" name="LabNumber" autocapitalize="characters" [matTooltip]="'Agency Case Number Or BRASSTRAX Case Number'">
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="4" rowHeight="80px">

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; padding: 3px;" >
          <mat-label>Incident Type</mat-label>
          <input matInput [disabled]="true" [(ngModel)]="data.Inc_Type" name="LabNumber" autocapitalize="characters" [matTooltip]="'Agency Case Number Or BRASSTRAX Case Number'">
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('INCIDENT', data, 'Inc_RelatedArea') ? 'ChangeHighlight' : ''" >
          <mat-label>Case Event Type</mat-label>
          <mat-select [(value)]="tempCaseEvent" multiple [disabled]="DisableDelta('INCIDENT', data, 'Inc_RelatedArea')">
            <mat-option (onSelectionChange)="selectCaseEventChange($event)" *ngFor="let ddlItem of ddls.RelatedArea" [value]="ddlItem.DDL_Desc"  [matTooltip]="ddlItem.DDL_Hover">
              {{ddlItem.DDL_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>

    </mat-grid-list>

    <mat-grid-list cols="2" rowHeight="80px">
      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('INCIDENT', data, 'Inc_Location') ? 'ChangeHighlight' : ''">
          <mat-label>Incident Address</mat-label>
          <input matInput [(ngModel)]="data.Inc_Location" name="location" autocapitalize="characters" [disabled]="DisableDelta('INCIDENT', data, 'Inc_Location')">
          <mat-hint>{{oldData.Inc_Location}}</mat-hint>
        </mat-form-field>

      </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="4" rowHeight="80px">

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; margin: 3px;">
          <mat-label>Incident State</mat-label>
          <input matInput [disabled]="true" [(ngModel)]="data.Inc_State" name="State" autocapitalize="characters">
        </mat-form-field>

      </mat-grid-tile>



      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('INCIDENT', data, 'County') ? 'ChangeHighlight' : ''">
          <mat-label>Incident County *</mat-label>

          <ng-container *ngIf="!DisableDelta('INCIDENT', data, 'County')">
            <input type="text" matInput [(ngModel)]="data.County" [matAutocomplete]="nibinIncidentCountyAutoComplete" name="nibinIncidentCountyAutoComplete" [formControl]="CNTRL_INC_COUNTY" >
            <mat-autocomplete #nibinIncidentCountyAutoComplete="matAutocomplete" autoActiveFirstOption (optionSelected)="updateCityAgencyList()" >
              <mat-option *ngFor="let c of FLTR_INC_COUNTY | async" [value]="c.County">
                {{c.County}}
              </mat-option>
            </mat-autocomplete>

            <button mat-button mat-icon-button matSuffix (click)="clearIncidentCounty()" *ngIf="data.County">
              <mat-icon>close</mat-icon>
            </button>
          </ng-container>
          <ng-container *ngIf="DisableDelta('INCIDENT', data, 'County')">
            <input matInput [(ngModel)]="data.County" name="County" autocapitalize="characters" [disabled]="DisableDelta('INCIDENT', data, 'County')" >
          </ng-container>

          <mat-hint>{{oldData.County}}</mat-hint>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('INCIDENT', data, 'Inc_City') ? 'ChangeHighlight' : ''">
          <mat-label>Incident City *</mat-label>
          <ng-container *ngIf="!DisableDelta('INCIDENT', data, 'Inc_City')">
            <input type="text" matInput [(ngModel)]="data.Inc_City" [matAutocomplete]="nibinIncidentCityAutoComplete" name="nibinIncidentCityAutoComplete" [formControl]="CNTRL_INC_CITY" [disabled]="DisableDelta('INCIDENT', data, 'Inc_City')">
            <mat-autocomplete #nibinIncidentCityAutoComplete="matAutocomplete" autoActiveFirstOption >
              <mat-option *ngFor="let c of FLTR_INC_CITY | async" [value]="c.City">
                {{c.City}}
              </mat-option>
            </mat-autocomplete>

            <button mat-button mat-icon-button matSuffix (click)="clearIncidentCity()" *ngIf="data.Inc_City">
              <mat-icon>close</mat-icon>
            </button>
          </ng-container>
          <ng-container *ngIf="DisableDelta('INCIDENT', data, 'Inc_City')">
            <input matInput [(ngModel)]="data.Inc_City" name="Inc_City" autocapitalize="characters" [disabled]="DisableDelta('INCIDENT', data, 'Inc_City')" >
          </ng-container>

          <mat-hint>{{oldData.Inc_City}}</mat-hint>
        </mat-form-field>
      </mat-grid-tile>


    </mat-grid-list>

  </form>
</mat-card>

<mat-card style="margin-top: 20px;" class="mat-elevation-z0 custom_outline">
  <mat-card-header>
    <mat-card-title>EVIDENCE DETAILS</mat-card-title>
  </mat-card-header>

  <h3>Linked Weapon</h3>

  <form>

    <mat-card *ngFor="let weapon of data.Weapon" class="mat-elevation-z0 custom_outline" style="margin: 10px;">
      <form>
        <mat-grid-list cols="4" rowHeight="100px">

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px;" [class]="!DisableDelta('WEAPON', weapon, 'MAKE') ? 'ChangeHighlight' : ''">
              <mat-label>MANUFACTURER *</mat-label>
              <input matInput [(ngModel)]="weapon.MAKE" name="Make" autocapitalize="characters" [disabled]="DisableDelta('WEAPON', weapon, 'MAKE')">
              <mat-hint>{{showDelta('WEAPON', weapon, 'MAKE')}}</mat-hint>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px;" [class]="!DisableDelta('WEAPON', weapon, 'MODEL') ? 'ChangeHighlight' : ''">
              <mat-label>MODEL *</mat-label>
              <input matInput [(ngModel)]="weapon.MODEL" name="MODEL" autocapitalize="characters" [disabled]="DisableDelta('WEAPON', weapon, 'MODEL')">
              <mat-hint>{{showDelta('WEAPON', weapon, 'MODEL')}}</mat-hint>
            </mat-form-field>

          </mat-grid-tile>


          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px;" [class]="!DisableDelta('WEAPON', weapon, 'CALIBER') ? 'ChangeHighlight' : ''">
              <mat-label>Caliber *</mat-label>
              <mat-select [(value)]="weapon.CALIBER" [disabled]="DisableDelta('WEAPON', weapon, 'CALIBER')">
                <mat-option *ngFor="let ddlItem of ddls.Caliber" [value]="ddlItem.DDL_Desc" [matTooltip]="ddlItem.DDL_Hover">
                  {{ddlItem.DDL_Desc}}
                </mat-option>
              </mat-select>
              <mat-hint>{{showDelta('WEAPON', weapon, 'CALIBER')}}</mat-hint>
            </mat-form-field>

          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px;" [class]="!DisableDelta('WEAPON', weapon, 'W_CLASS') ? 'ChangeHighlight' : ''">
              <mat-label>Classification *</mat-label>
              <mat-select [(value)]="weapon.W_CLASS" [disabled]="DisableDelta('WEAPON', weapon, 'W_CLASS')">
                <mat-option *ngFor="let ddlItem of ddls.WeaponClassification" [value]="ddlItem.DDL_Desc" [matTooltip]="ddlItem.DDL_Hover">
                  {{ddlItem.DDL_Desc}}
                </mat-option>
              </mat-select>
              <mat-hint>{{showDelta('WEAPON', weapon, 'W_CLASS')}}</mat-hint>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('WEAPON', weapon, 'SERIAL_NUMBER') ? 'ChangeHighlight' : ''">
              <mat-label>Serial</mat-label>
              <input matInput [(ngModel)]="weapon.SERIAL_NUMBER" name="serial" autocapitalize="characters" [disabled]="DisableDelta('WEAPON', weapon, 'SERIAL_NUMBER')">
              <mat-hint>{{showDelta('WEAPON', weapon, 'SERIAL_NUMBER')}}</mat-hint>
            </mat-form-field>

          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('WEAPON', weapon, 'EvidenceMarker') ? 'ChangeHighlight' : ''">
              <mat-label>Exhibit Marker</mat-label>
              <input matInput [(ngModel)]="weapon.EvidenceMarker" name="marker" autocapitalize="characters" [disabled]="DisableDelta('WEAPON', weapon, 'EvidenceMarker')">
              <mat-hint>{{showDelta('WEAPON', weapon, 'EvidenceMarker')}}</mat-hint>
            </mat-form-field>

          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('WEAPON', weapon, 'DTOFCOLLECTION') ? 'ChangeHighlight' : ''">
              <mat-label>Date of Collection:</mat-label>
              <input matInput [matDatepicker]="WPNDTOFCOLDatePicker" [(ngModel)]="weapon.DTOFCOLLECTION" name="DTOFCOL" [disabled]="DisableDelta('WEAPON', weapon, 'DTOFCOLLECTION')">
              <mat-datepicker-toggle matSuffix [for]="WPNDTOFCOLDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #WPNDTOFCOLDatePicker></mat-datepicker>
              <mat-hint>{{showDelta('WEAPON', weapon, 'DTOFCOLLECTION')}}</mat-hint>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('WEAPON', weapon, 'DTOFSUBMISSION') ? 'ChangeHighlight' : ''" >

              <input matInput [matDatepicker]="WPNDTOFSUBDatePicker" [(ngModel)]="weapon.DTOFSUBMISSION" name="DTOFSUB" [disabled]="DisableDelta('WEAPON', weapon, 'DTOFSUBMISSION')">
              <mat-datepicker-toggle matSuffix [for]="WPNDTOFSUBDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #WPNDTOFSUBDatePicker></mat-datepicker>
              <mat-label>Date of Submission:</mat-label>
              <mat-hint>{{showDelta('WEAPON', weapon, 'DTOFSUBMISSION')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1" dense>
            <mat-checkbox [checked]="weapon.CT_Ghost_Gun" (change)="setWeaponCheck($event.checked, weapon)">
              Ghost Gun
            </mat-checkbox>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1" dense>
            <mat-checkbox [checked]="weapon.SearModifyFlag" (change)="setSearModifyFlag($event.checked, weapon)">
              Sear Modified
            </mat-checkbox>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="4" [rowspan]="1" dense>
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('WEAPON', weapon, 'Notes') ? 'ChangeHighlight' : ''">
              <mat-label>Notes</mat-label>
              <input matInput [(ngModel)]="weapon.Notes" name="notes" autocapitalize="characters" [disabled]="DisableDelta('WEAPON', weapon, 'Notes')">
              <mat-hint>{{showDelta('WEAPON', weapon, 'Notes')}}</mat-hint>
            </mat-form-field>

          </mat-grid-tile>

        </mat-grid-list>




        <button mat-button (click)="deleteWeaponRecord(weapon)" style="color:red;">DELETE</button>
      </form>
    </mat-card>

  </form>


  <h3>Linked Cartridge Cases</h3>

  <form>
    <mat-card *ngFor="let ballistic of data.Ballistics" class="mat-elevation-z0 custom_outline" style="margin: 10px;">
      <form *ngIf="ballistic.VGID_CPart?.toUpperCase() === 'Cartridge Case'.toUpperCase()">
        <mat-grid-list cols="5" rowHeight="75px">

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('BALLISTICS', ballistic, 'Item_Quantity') ? 'ChangeHighlight' : ''">
              <mat-label>Quantity in Cluster</mat-label>
              <input matInput [(ngModel)]="ballistic.Item_Quantity" name="Qty" mask="999" [disabled]="DisableDelta('BALLISTICS', ballistic, 'Item_Quantity')">
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'Item_Quantity')}}</mat-hint>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('BALLISTICS', ballistic, 'Caliber_Type') ? 'ChangeHighlight' : ''">
              <mat-label>Caliber</mat-label>
              <mat-select [(value)]="ballistic.Caliber_Type" [disabled]="DisableDelta('BALLISTICS', ballistic, 'Caliber_Type')">
                <mat-option *ngFor="let ddlItem of ddls.Caliber" [value]="ddlItem.DDL_Desc" [matTooltip]="ddlItem.DDL_Hover">
                  {{ddlItem.DDL_Desc}}
                </mat-option>
              </mat-select>
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'Caliber_Type')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('BALLISTICS', ballistic, 'EvidenceMarker') ? 'ChangeHighlight' : ''">
              <mat-label>Marker(EVID/TFID)</mat-label>
              <input matInput [(ngModel)]="ballistic.EvidenceMarker" name="Marker" autocapitalize="characters" [disabled]="DisableDelta('BALLISTICS', ballistic, 'EvidenceMarker')">
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'EvidenceMarker')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('BALLISTICS', ballistic, 'DTOFCOLLECTION') ? 'ChangeHighlight' : ''">
              <mat-label>Date of Collection:</mat-label>
              <input matInput [matDatepicker]="BALDTOFCOLDatePicker" [(ngModel)]="ballistic.DTOFCOLLECTION" name="BALDTOFCOL" [disabled]="DisableDelta('BALLISTICS', ballistic, 'DTOFCOLLECTION')">
              <mat-datepicker-toggle matSuffix [for]="BALDTOFCOLDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #BALDTOFCOLDatePicker></mat-datepicker>
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'DTOFCOLLECTION')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('BALLISTICS', ballistic, 'BALDTOFSUB') ? 'ChangeHighlight' : ''">
              <mat-label>Date of Submission:</mat-label>
              <input matInput [matDatepicker]="BALDTOFSUBDatePicker" [(ngModel)]="ballistic.DTOFSUBMISSION" name="BALDTOFSUB" [disabled]="DisableDelta('BALLISTICS', ballistic, 'BALDTOFSUB')">
              <mat-datepicker-toggle matSuffix [for]="BALDTOFSUBDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #BALDTOFSUBDatePicker></mat-datepicker>
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'DTOFSUBMISSION')}}</mat-hint>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="5" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('BALLISTICS', ballistic, 'Notes') ? 'ChangeHighlight' : ''">
              <mat-label>Notes</mat-label>
              <input matInput [(ngModel)]="ballistic.Notes" name="Notes" [disabled]="DisableDelta('BALLISTICS', ballistic, 'Notes')">
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'Notes')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>
        </mat-grid-list>
      </form>

      <form *ngIf="ballistic.VGID_CPart?.toUpperCase() === 'Projectile'.toUpperCase()">
        <mat-grid-list cols="7" rowHeight="75px">

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('BALLISTICS', ballistic, 'Item_Quantity') ? 'ChangeHighlight' : ''">
              <mat-label>Quantity in Cluster</mat-label>
              <input matInput [(ngModel)]="ballistic.Item_Quantity" name="Qty" mask="999" [disabled]="DisableDelta('BALLISTICS', ballistic, 'Item_Quantity')">
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'Item_Quantity')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('BALLISTICS', ballistic, 'Caliber_Type') ? 'ChangeHighlight' : ''">
              <mat-label>Caliber</mat-label>
              <mat-select [(value)]="ballistic.Caliber_Type" [disabled]="DisableDelta('BALLISTICS', ballistic, 'Caliber_Type')">
                <mat-option *ngFor="let ddlItem of ddls.Caliber" [value]="ddlItem.DDL_Desc" [matTooltip]="ddlItem.DDL_Hover">
                  {{ddlItem.DDL_Desc}}
                </mat-option>
              </mat-select>
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'Caliber_Type')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('BALLISTICS', ballistic, 'CL_LG') ? 'ChangeHighlight' : ''">
              <mat-label>CL-L&G</mat-label>
              <mat-select [(value)]="ballistic.CL_LG" [disabled]="DisableDelta('BALLISTICS', ballistic, 'CL_LG')">
                <mat-option [value]="'1'" >1</mat-option>
                <mat-option [value]="'2'" >2</mat-option>
                <mat-option [value]="'3'" >3</mat-option>
                <mat-option [value]="'4'" >4</mat-option>
                <mat-option [value]="'5'" >5</mat-option>
                <mat-option [value]="'6'" >6</mat-option>
                <mat-option [value]="'7'" >7</mat-option>
                <mat-option [value]="'8'" >8</mat-option>
                <mat-option [value]="'9'" >9</mat-option>
                <mat-option [value]="'10'" >10</mat-option>
                <mat-option [value]="'11'" >11</mat-option>
                <mat-option [value]="'12'" >12</mat-option>
              </mat-select>
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'CL_LG')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('BALLISTICS', ballistic, 'CL_Twist') ? 'ChangeHighlight' : ''">
              <mat-label>CL-Twist</mat-label>
              <mat-select [(value)]="ballistic.CL_Twist" [disabled]="DisableDelta('BALLISTICS', ballistic, 'CL_Twist')">
                <mat-option [value]="'LEFT'" >Left</mat-option>
                <mat-option [value]="'RIGHT'" >Right</mat-option>
              </mat-select>
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'CL_Twist')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('BALLISTICS', ballistic, 'CL_Type') ? 'ChangeHighlight' : ''">
              <mat-label>CL-Type</mat-label>
              <mat-select [(value)]="ballistic.CL_Type" [disabled]="DisableDelta('BALLISTICS', ballistic, 'CL_Type')">
                <mat-option [value]="'CONVENTIONAL'" >Conventional</mat-option>
                <mat-option [value]="'POLY'" >Poly</mat-option>
              </mat-select>
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'CL_Type')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>



          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('BALLISTICS', ballistic, 'DTOFCOLLECTION') ? 'ChangeHighlight' : ''">
              <mat-label>Date of Collection:</mat-label>
              <input matInput [matDatepicker]="BALDTOFCOLDatePicker" [(ngModel)]="ballistic.DTOFCOLLECTION" name="BALDTOFCOL" [disabled]="DisableDelta('BALLISTICS', ballistic, 'DTOFCOLLECTION')">
              <mat-datepicker-toggle matSuffix [for]="BALDTOFCOLDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #BALDTOFCOLDatePicker></mat-datepicker>
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'DTOFCOLLECTION')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('WEAPON', ballistic, 'DTOFSUBMISSION') ? 'ChangeHighlight' : ''">
              <mat-label>Date of Submission:</mat-label>
              <input matInput [matDatepicker]="BALDTOFSUBDatePicker" [(ngModel)]="ballistic.DTOFSUBMISSION" name="BALDTOFSUB" [disabled]="DisableDelta('BALLISTICS', ballistic, 'DTOFSUBMISSION')">
              <mat-datepicker-toggle matSuffix [for]="BALDTOFSUBDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #BALDTOFSUBDatePicker></mat-datepicker>
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'DTOFSUBMISSION')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="7" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('BALLISTICS', ballistic, 'Notes') ? 'ChangeHighlight' : ''">
              <mat-label>Notes</mat-label>
              <input matInput [(ngModel)]="ballistic.Notes" name="Notes" [disabled]="DisableDelta('BALLISTICS', ballistic, 'Notes')">
              <mat-hint>{{showDelta('BALLISTICS', ballistic, 'Notes')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

        </mat-grid-list>
      </form>
      <button mat-button (click)="deleteBallisticsRecord(ballistic)" style="color:red;">DELETE</button>
    </mat-card>

  </form>

</mat-card>

<mat-card style="margin-top: 20px;" class="mat-elevation-z0 custom_outline">
  <mat-card-header>
    <mat-card-title>PEOPLE DETAILS</mat-card-title>
  </mat-card-header>

  <form>
    <mat-card *ngFor="let person of data.Persons" class="mat-elevation-z0 custom_outline" style="margin: 10px;">
      <form>
        <mat-grid-list cols="4" rowHeight="75px">

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('PERSON', person, 'Role') ? 'ChangeHighlight' : ''">
              <mat-label>Role</mat-label>
              <mat-select [(value)]="person.Role" [disabled]="DisableDelta('PERSON', person, 'Role')">
                <mat-option value="INVESTIGATOR">
                  INVESTIGATOR
                </mat-option>
                <mat-option value="OTHER">
                  OTHER
                </mat-option>
                <mat-option value="SUSPECT">
                  SUSPECT
                </mat-option>
                <mat-option value="SUSPECT/VICTIM">
                  SUSPECT/VICTIM
                </mat-option>
                <mat-option value="VICTIM">
                  VICTIM
                </mat-option>
                <mat-option value="WITNESS">
                  WITNESS
                </mat-option>
              </mat-select>
              <mat-hint>{{showDelta('PERSON', person, 'Role')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('PERSON', person, 'FIRSTNAME') ? 'ChangeHighlight' : ''">
              <mat-label>First Name</mat-label>
              <input matInput [(ngModel)]="person.FIRSTNAME"  [ngModelOptions]="{standalone: true}" [disabled]="DisableDelta('PERSON', person, 'FIRSTNAME')">
              <mat-hint>{{showDelta('PERSON', person, 'FIRSTNAME')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('PERSON', person, 'MI') ? 'ChangeHighlight' : ''">
              <mat-label>MI</mat-label>
              <input matInput [(ngModel)]="person.MI"  [ngModelOptions]="{standalone: true}" [disabled]="DisableDelta('PERSON', person, 'MI')">
              <mat-hint>{{showDelta('PERSON', person, 'MI')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('PERSON', person, 'LASTNAME') ? 'ChangeHighlight' : ''">
              <mat-label>Last Name</mat-label>
              <input matInput [(ngModel)]="person.LASTNAME" [ngModelOptions]="{standalone: true}" [disabled]="DisableDelta('PERSON', person, 'LASTNAME')">
              <mat-hint>{{showDelta('PERSON', person, 'LASTNAME')}}</mat-hint>

            </mat-form-field>

          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('PERSON', person, 'Suffix') ? 'ChangeHighlight' : ''">
              <mat-label>Suffix</mat-label>
              <input matInput [(ngModel)]="person.Suffix" [ngModelOptions]="{standalone: true}" [disabled]="DisableDelta('PERSON', person, 'Suffix')">
              <mat-hint>{{showDelta('PERSON', person, 'Suffix')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>


          <mat-grid-tile [colspan]="1" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() !== 'Investigator'.toUpperCase()">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('PERSON', person, 'SBINo') ? 'ChangeHighlight' : ''">
              <mat-label>SBI</mat-label>
              <input matInput [(ngModel)]="person.SBINo" [ngModelOptions]="{standalone: true}" [disabled]="DisableDelta('PERSON', person, 'SBINo')">
              <mat-hint>{{showDelta('PERSON', person, 'SBINo')}}</mat-hint>

            </mat-form-field>

          </mat-grid-tile>


          <mat-grid-tile [colspan]="1" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() !== 'Investigator'.toUpperCase()">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('PERSON', person, 'FBI') ? 'ChangeHighlight' : ''">
              <mat-label>FBI</mat-label>
              <input matInput [(ngModel)]="person.FBI" [ngModelOptions]="{standalone: true}" [disabled]="DisableDelta('PERSON', person, 'FBI')">
              <mat-hint>{{showDelta('PERSON', person, 'FBI')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() === 'Investigator'.toUpperCase()">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('PERSON', person, 'Email') ? 'ChangeHighlight' : ''">
              <mat-label>Email</mat-label>
              <input matInput [(ngModel)]="person.Email" [ngModelOptions]="{standalone: true}" [disabled]="DisableDelta('PERSON', person, 'Email')">
              <mat-hint>{{showDelta('PERSON', person, 'Email')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() === 'Investigator'.toUpperCase()">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('PERSON', person, 'Rank') ? 'ChangeHighlight' : ''">
              <mat-label>Rank</mat-label>
              <input matInput [(ngModel)]="person.Rank"  [ngModelOptions]="{standalone: true}" [disabled]="DisableDelta('PERSON', person, 'Rank')">
              <mat-hint>{{showDelta('PERSON', person, 'Rank')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() === 'Investigator'.toUpperCase()">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('PERSON', person, 'Phone') ? 'ChangeHighlight' : ''">
              <mat-label>Phone</mat-label>
              <input matInput [(ngModel)]="person.Phone" [ngModelOptions]="{standalone: true}" mask="(000) 000-0000" [disabled]="DisableDelta('PERSON', person, 'Phone')">
              <mat-hint>{{showDelta('PERSON', person, 'Phone')}}</mat-hint>

            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() !== 'Investigator'.toUpperCase()">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('PERSON', person, 'DOB') ? 'ChangeHighlight' : ''">
              <mat-label>DOB</mat-label>

              <input matInput [matDatepicker]="PDOBDatePicker" [(ngModel)]="person.DOB" name="PDOB" [disabled]="DisableDelta('PERSON', person, 'DOB')">
              <mat-datepicker-toggle matSuffix [for]="PDOBDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #PDOBDatePicker></mat-datepicker>
              <mat-hint>{{showDelta('PERSON', person, 'DOB')}}</mat-hint>

            </mat-form-field>

          </mat-grid-tile>


          <mat-grid-tile [colspan]="4" [rowspan]="1" dense>
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; " [class]="!DisableDelta('PERSON', person, 'AdditionalNotes') ? 'ChangeHighlight' : ''">
              <mat-label>Notes</mat-label>
              <input matInput [(ngModel)]="person.AdditionalNotes" [ngModelOptions]="{standalone: true}" [disabled]="DisableDelta('PERSON', person, 'AdditionalNotes')">
              <mat-hint>{{showDelta('PERSON', person, 'AdditionalNotes')}}</mat-hint>
            </mat-form-field>
          </mat-grid-tile>
        </mat-grid-list>

        <button mat-button (click)="deletePersonRecord(person)" style="color:red;">DELETE</button>
      </form>
    </mat-card>
  </form>

</mat-card>


<div style="margin-top:25px; width: 100%; display: block; height: 50px;float: right;" >
  <button mat-stroked-button style="background-color: yellow; border: black 3px solid; margin: 2px;" (click)="cancelChanges()">CANCEL CHANGES</button>
  <button mat-stroked-button style="background-color: red; border: black 3px solid; margin: 2px;" (click)="rejectChanges()">REJECT CHANGES</button>
  <button mat-stroked-button style="background-color: green; border: black 3px solid;margin: 2px;" (click)="saveChanges()">ACCEPT CHANGES</button>
</div>


